/* istanbul ignore file */
export default ({ palette, typography }) => ({
  loadingColor: palette.primary.normal,
  loadingSize: 30,
  loadingWidth: 4,
  fontFamily: typography.fontFamily,
  textColor: palette.text.dark,
  backgroundColor: palette.highlightBackground,
  dark: {
    textColor: palette.text.light
  }
});
